import template from './fiscal-sales-visualizer.html';
import controller from './fiscal-sales-visualizer.controller';
import './fiscal-sales-visualizer.scss';

let FiscalSalesVisualizerComponent = {
  bindings: {},
  template,
  controller
};

export default FiscalSalesVisualizerComponent;



// WEBPACK FOOTER //
// ./src/app/pages/fiscal-sales-visualizer/fiscal-sales-visualizer.component.js